import Page from '@/features/Services/pages/HRPrivacy'

export default Page
